<template>
  <a-transfer
    :data-source="mockData"
    :list-style="{
      width: '235px',
      height: '300px',
    }"
    :target-keys="targetKeys"
    :render="renderItem"
    @change="handleChange"
  />
</template>
<script>
export default {
  props: ["controlTableColumns"],
  data() {
    return {
      mockData: [],
      targetKeys: [],
    };
  },
  methods: {
    getMock() {
      const targetKeys = [];
      const mockData = [];
      for (let i in this.controlTableColumns.plainOptions) {
        let title = this.controlTableColumns.plainOptions[i];
        const data = {
          key: i.toString(),
          title,
        };
        if (this.controlTableColumns.checkedList.includes(title)) {
          targetKeys.push(data.key);
        }
        mockData.push(data);
      }
      this.mockData = mockData;
      this.targetKeys = targetKeys;
    },
    renderItem(item) {
      const customLabel = <span class="custom-item">{item.title}</span>;
      return {
        label: customLabel,
        value: item.title,
      };
    },
    handleChange(targetKeys, direction, moveKeys) {
      if (direction == "right") {
        this.targetKeys = this.targetKeys.concat(moveKeys);
      } else {
        this.targetKeys = targetKeys;
      }
      let kk = [];
      for (let i of this.targetKeys) {
        kk.push(
          this.controlTableColumns.plainOptions.find((el, index) => index == i)
        );
      }
      this.controlTableColumns.checkedList = kk;
    },
  },
  mounted() {
    this.getMock();
  },
};
</script>
